/**
 * V6.0.29 — Haptic feedback helper.
 *
 * Uses `navigator.vibrate` when available (Android Chrome, most PWAs).
 * iOS Safari doesn't expose the Vibration API natively, but on PWAs added
 * to home-screen via newer iOS releases this becomes a no-op gracefully.
 *
 * Usage:
 *   import { haptic } from '../utils/haptics';
 *   haptic.tap();        // light micro-tap (8 ms)
 *   haptic.success();    // 2-pulse success
 *   haptic.warning();    // longer warning
 *   haptic.swipe();      // short slide confirm
 *   haptic.heavy();      // big impact (delete, error)
 */

const safeVibrate = (pattern) => {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern);
    }
  } catch (_) { /* ignore — never throw from a UI hook */ }
};

export const haptic = {
  tap:     () => safeVibrate(8),
  swipe:   () => safeVibrate(12),
  success: () => safeVibrate([10, 40, 10]),
  warning: () => safeVibrate([20, 60, 20]),
  heavy:   () => safeVibrate(30),
};

export default haptic;
